import { SessionInDto } from "../../../types/session.dto";

export const DUPLICATE_SESSION = "DUPLICATE_SESSION";
export const DUPLICATE_SESSION_SUCCESS = "DUPLICATE_SESSION_SUCCESS";
export const DUPLICATE_SESSION_ERROR = "DUPLICATE_SESSION_ERROR";
export const RESET_DUPLICATE_SESSION = "RESET_DUPLICATE_SESSION";

export interface DuplicateSession {
  type: typeof DUPLICATE_SESSION;
  payload: {
    idSession: number;
    [key: string]: any;
  };
}

export interface DuplicateSessionSuccess {
  type: typeof DUPLICATE_SESSION_SUCCESS;
  payload: SessionInDto;
}

export interface DuplicateSessionError {
  type: typeof DUPLICATE_SESSION_ERROR;
  payload: string | boolean;
}

export interface ResetDuplicateSession {
  type: typeof RESET_DUPLICATE_SESSION;
  payload: null;
}

export interface State {
  data: SessionInDto | null;
  states: {
    success: boolean;
    loading: boolean;
    error: boolean | string;
  };
}

export const initialState: State = {
  data: null,
  states: {
    success: false,
    loading: false,
    error: false,
  },
};

export type Actions =
  | DuplicateSession
  | DuplicateSessionSuccess
  | DuplicateSessionError
  | ResetDuplicateSession;
